module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "con"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/07_chapter01#c1"
    }
  }, [_vm._v("1 • Premise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/08_chapter02#c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 • Heart-Centered Activism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter03#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 • Moving Toward the Millionth Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter04#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 • Stone Cutters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 • Sovereignty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 • Circle or/and Hierarchy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 • Path with Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 • The Dalai Lama and the Millionth Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_appreciation#apprec",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appreciation")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c3e8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_contents.vue
// module id = 72
// module chunks = 0